import { Modal, Button } from "react-bootstrap";

export const ConfirmationModal = (props) => {
  return (
    <Modal show={props.modalOpen} onHide={props.onCancel} size="md" centered>
        <Modal.Header closeButton>
            <Modal.Title className="text-center">
                {props.title}
            </Modal.Title>
        </Modal.Header>
        <Modal.Body className="text-center">
            <p className="">{props.content}</p>
            <Button variant="success" className="me-2" onClick={props.onConfirm}>Yes</Button>
            <Button variant="danger" onClick={props.onCancel}>No</Button>
        </Modal.Body>
    </Modal>
  );
};
